const baseImageUrl = (image: string) => {
  return `${process.env.NEXT_PUBLIC_BACKEND_URL?.replace('api/v1', '')}${image}`;
};

export default baseImageUrl;
